module.exports = __webpack_public_path__ + "src/assets/img/bg-box02.be0ca6d3.png";